import { ref } from '@vue/composition-api';
import { useBSOptionAuthorityApi, useBSThirdSupportCountryApi } from '@tt4b/ttam-hooks';
import { BrandSafetyTrackTypeMap } from '@tt4b/ttam-enums';

let isFetchData = false;
const isLoading = ref(false);

const hasZefrAuthority = ref(false);
const supportBsZefrCountryList = ref<number[]>([]);

const hasBsIasAuthority = ref(false);
const supportBsIasCountryList = ref<number[]>([]);

const hasBsDvAuthority = ref(false);
const supportBsDvCountryList = ref<number[]>([]);

export function useBrandSafetySupport() {
  async function load() {
    // 目前只要请求一次，不需要重复请求
    if (isFetchData) {
      return;
    }

    isLoading.value = true;
    await Promise.all([
      useBSOptionAuthorityApi(BrandSafetyTrackTypeMap.IAS),
      useBSOptionAuthorityApi(BrandSafetyTrackTypeMap.ZEFR),
      useBSOptionAuthorityApi(BrandSafetyTrackTypeMap.DV),
      useBSThirdSupportCountryApi(BrandSafetyTrackTypeMap.IAS),
      useBSThirdSupportCountryApi(BrandSafetyTrackTypeMap.ZEFR),
      useBSThirdSupportCountryApi(BrandSafetyTrackTypeMap.DV),
    ])
      .then(([hasBsIas, hasZefr, hasDv, iasSupport, zefrSupport, dvSupport]) => {
        hasZefrAuthority.value = hasZefr;
        hasBsIasAuthority.value = hasBsIas;
        hasBsDvAuthority.value = hasDv;

        supportBsIasCountryList.value = iasSupport;
        supportBsZefrCountryList.value = zefrSupport;
        supportBsDvCountryList.value = dvSupport;

        // 标识已经成功请求了
        isFetchData = true;
      })
      .finally(() => {
        isLoading.value = false;
      });
  }

  return {
    isFetchData,
    isLoading,
    hasZefrAuthority,
    supportBsZefrCountryList,
    hasBsIasAuthority,
    supportBsIasCountryList,
    hasBsDvAuthority,
    supportBsDvCountryList,
    load,
  };
}
